import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';

export abstract class AbstractRtpAccountActivityCorrespondentService extends ITableService {}
